<template>
    <div id="app">
        <v-app id="inspire">
            <v-card-title>
                <span class="headline">Inutilizar NFe</span>
            </v-card-title>
            <v-container grid-list-xl>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout class="mt-3" row align-end justify-space-between>
                            <v-flex xs12 sm12 md5>
                                <v-text-field
                                    v-model="newInut.empresas_id.nome"
                                    label="Empresas"
                                    readonly
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md5>
                                <v-text-field v-model="newInut.serie" label="Série"  :rules="obgRules" required></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row align-end justify-space-between>
                            <v-flex xs12 sm12 md5>
                                <v-text-field v-model="newInut.numero_inicial" label="Número Inicial da faixa a ser inutilizada"  :rules="obgRules" required></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md5>
                                <v-text-field v-model="newInut.numero_final" label="Número Final da faixa a ser inutilizada"  :rules="obgRules" required></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row align-end justify-space-between>
                            <v-flex xs12 sm12 md5>
                                <v-combobox
                                    v-model="newInut.tp_Amb"
                                    :items="idAmbiente"
                                    hide-no-data
                                    hide-selected
                                    item-text="nome"
                                    item-value="id"
                                    label="Identificação do Ambiente"
                                    placeholder="Comece a digitar para procurar"
                                    return-object
                                ></v-combobox>
                            </v-flex>
                            <v-flex xs12 sm12 md5>
                                <v-combobox
                                    v-model="newInut.tp_doc"
                                    :items="tipoDoc"
                                    label="Documento Fiscal"
                                    hide-no-data
                                    hide-selected
                                    item-text="nome"
                                    item-value="id"
                                    placeholder="Comece a digitar para procurar"
                                    :rules="obgRules"
                                    required
                                >
                                </v-combobox>
                            </v-flex>
                        </v-layout>
                        <v-layout row align-end justify-space-between>
                            <v-flex xs12 sm12 md5>
                                <v-textarea
                                    rows = "4"
                                    label="Justificativa"
                                    v-model="newInut.justificativa_inutilizacao"
                                ></v-textarea>
                            </v-flex>
                        </v-layout>
                    </v-form>
                    <v-layout class="mt-4" row align-end>
                        <v-btn class="ml-2" color="success" @click="cancelarNfe">
                            Salvar
                        </v-btn>
                        <v-btn color="error" @click="reset">
                            Cancelar
                        </v-btn>
                        <v-btn color="warning" @click="back">
                            Voltar
                        </v-btn>
                    </v-layout>
                <v-layout class="mt-4">
                    <v-flex xs12 md12>
                        <v-textarea
                            v-if="envio"
                            disabled
                            outline
                            no-resize
                            rows = "5"
                            name="inputEnvio"
                            label="Envio"
                            :value="envio"
                        ></v-textarea>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12 md12>
                        <v-textarea
                            v-if="mostrar"
                            disabled
                            outline
                            no-resize
                            color="purple"
                            rows = "5"
                            name="inputMostrar"
                            label="Resposta"
                            :value="mostrar"
                        ></v-textarea>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </div>
</template>

<script>

    import {sharedService} from '../services'

    export default {
        name: 'NFeInutilizar',
        data() {
            return {
                loadingEmpresas: false,
                searchEmpresa: '',
                tipoEmpresas: [],
                id: 0,
                newInut: {
                    empresas_id: {
                        id: '', 
                        nome: ''
                    },
                    serie: '',
                    numero_inicial: '',
                    numero_final: '',
                    justificativa_inutilizacao: '',
                    tp_Amb: '',
                    tp_doc: ''
                },
                valid: true,
                dialog: false,
                text: '',
                mostrar: '',
                envio: '',
                idAmbiente: [
                    {  id: '1', nome: '1-Produção'},
                    {  id: '2', nome: '2-Homologação'}
                ],
                tipoDoc: [
                    {id: '55', nome: 'NFe'},
                    {id: '65', nome: 'NFCe'}
                ],
                obgRules: [
                    v => !!v || 'Este campo é obrigatório'
                ]
            }
        },
        created () {
            if (this.$route.params.id) {
                this.id = this.$route.params.id
            }
        },
        computed: {
            empresa: function () {
                let self = this
                self.empresaTes = this.$store.getters.getEmpresa
                return this.$store.getters.getEmpresa
            }
        },
        methods: {
            back () {
                this.$router.push({
                    name: 'Nfe'
                })  
            },
            reset () {
                this.$refs.form.reset()
            },
            close () {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex2 = -1
                }, 300)
            },
            getEmpresa () {
                let self = this
                let busca = 'filtros=[["nome_fantasia","like","'+self.empresaTes.nome+'%"]]'

                sharedService.read('Empresas?'+busca).then(function (obj){
                    for (var key in obj.obj) {
                        let obje = {
                            id: obj.obj[key].id,
                            nome: obj.obj[key].nome_fantasia
                        }
                        self.newInut.empresas_id.id = obje.id
                        self.newInut.empresas_id.nome = obje.nome
                    }
                })
            },
            cancelarNfe(){
                let self = this
                this.$confirm('Tem certeza que deseja excluir este item?').then(res => {
                    if (res) {
                        if (this.$refs.form.validate()) {
                            sharedService.create('NFe/inutilizar', this.newInut).then(function (obj){
                                self.envio = JSON.stringify(self.newInut)
                                obj.text().then(function (text){
                                    self.mostrar = text
                                    if(obj.status === 200){
                                        self.$store.dispatch('success', 'NFe inutilizada com sucesso!')
                                    }  else {
                                        self.$store.dispatch('error', text)
                                    }
                                     self.close3()
                                })
                            })
                        } else {
                            alert('Preencha os campos obrigatórios!')
                        }
                    } else {
                        this.close()
                    }
                })
            }
        },
        watch: {
            empresa: function () {
                if(this.empresa){
                    this.empresaTes = this.empresa
                    this.getEmpresa()
                    this.getPosicao()
                }
            }
        },
        beforeMount(){
            this.getEmpresa()
        }
    }
</script>